module.exports = "/res/wvgovlogo.bf61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wvgovlogo.png
// module id = 410
// module chunks = 0